import { gsap } from "gsap";

import { AbstractSpine } from "../../../../abstracts/graphics/AbstractSpine";
import { DDDSpineNames } from "../../../assetsLoader/DDDAssetsNames";
import { symbolConfig } from "../../../config/DDDConfig";
import { DDDSymbolNames } from "../../../types/DDDEnums";
import { DDDSymbol } from "./DDDSymbol";

export class DDDXGodSymbol extends DDDSymbol {
    override set isSpinning(value: boolean) {
        this._isSpinning = value;

        if (this.mainSpine && value) {
            this.mainSpine.reset();
            this.mainSpine.state.setAnimation(0, `spin`, false);
        }
    }

    protected generateSymbol(): void {
        this.mainSpine = new AbstractSpine(DDDSpineNames.XGOD);
        this.mainSpine.name = `${this.name}`;
        this.mainSpine.scale.set(0.5);
        this.mainSpine.x = symbolConfig.symbolWidth / 2;
        switch (this.name) {
            case DDDSymbolNames.XGOD_2:
                this.mainSpine.y = -symbolConfig.symbolHeight;
                break;

            case DDDSymbolNames.XGOD_3:
                this.mainSpine.y = -symbolConfig.symbolHeight * 2;
                break;

            default:
                this.mainSpine.y = 0;
                break;
        }
        this.mainSpine.y += 283;
        this.mainSpine.alpha = 1;

        this.addChild(this.mainSpine);
    }

    public override getLandingAnimation(): gsap.core.Tween | gsap.core.Timeline {
        return this.mainSpine.getSpineTween(`landing`);
    }

    public getIdleAnimation(): gsap.core.Tween {
        return gsap.to({}, { duration: 0 });
    }

    public getWinAnimation(): gsap.core.Tween | gsap.core.Timeline {
        const newSpine = new AbstractSpine(DDDSpineNames.XGOD);
        newSpine.name = `xGodClone`;
        newSpine.scale.set(this.mainSpine.scale.x);
        newSpine.x = this.mainSpine.x;
        newSpine.y = this.mainSpine.y;
        newSpine.alpha = 1;

        const tl = gsap.timeline({
            smoothChildTiming: true,
            autoRemoveChildren: true,
            onStart: () => {
                this.addChild(newSpine);
                this.mainSpine.alpha = 0;
                this.alpha = 1;
            },
            onComplete: () => {
                newSpine.destroy();
                gsap.delayedCall(0.3, () => {
                    this.mainSpine.alpha = 1;
                    this.alpha = 1;
                });
            },
        });

        tl.add(newSpine.getSpineTween(`explode`), 0);

        return tl;
    }

    public override resetOnStartSpin() {
        super.resetOnStartSpin();
    }

    public override reset(): void {
        super.reset();

        switch (this.name) {
            case DDDSymbolNames.XGOD_2:
                this.mainSpine.y = -symbolConfig.symbolHeight;
                break;
            case DDDSymbolNames.XGOD_3:
                this.mainSpine.y = -symbolConfig.symbolHeight * 2;
                break;
            default:
                this.mainSpine.y = 0;
                break;
        }
        this.mainSpine.y += 278;

        this.visible = true;
    }

    protected override resetMainSpine(isSpin: boolean = false): void {
        if (this.mainSpine !== undefined) {
            this.mainSpine.reset();

            this.mainSpine.getSpineTween(`Normal`);

            if (!isSpin) {
                this.mainSpine.mask = null;
                this.mainSpine.scale.set(0.5);
            }

            this.addChild(this.mainSpine);
        }
    }
}
